import {
  CheckoutStateEnum,
  ICheckoutCart,
  PaymentMethodSource,
} from '@monofront/types';
import { PaypalTypesEnum } from '@monofront/business/constants';
import { useCheckoutCartState } from '@monofront/business/contexts';
import { useCheckoutPayment } from '../contexts';
import PayCtaDisabled from './PayCtaDisabled';
import PayNothingCta from './PayNothingCta';
import PayWithExistingCardCta from './PayWithExistingCardCta';
import PayWithExistingPaypalCta from './PayWithExistingPaypalCta';
import PayWithNewCardCta from './PayWithNewCardCta';
import PayWithNewPaypalCta from './PayWithNewPaypalCta';
import PayWithApplePayCta from './PayWithApplePayCta';
import PayWithNewPaypalAgreementCta from './PayWithNewPaypalAgreementCta';

interface IPaymentActionsProps {
  checkoutCart?: ICheckoutCart;
}

/**
 * Display the correct Action CTA to pay and complete the order
 */
const PaymentActions: React.FC<IPaymentActionsProps> = () => {
  const { checkoutCart } = useCheckoutCartState();
  const {
    selectedExistingPaymentMethod,
    selectedNewCheckoutComCard,
    selectedNewPaypal,
    selectedNewApplePay,
  } = useCheckoutPayment();

  if (CheckoutStateEnum.PAYMENT_SKIPPED === checkoutCart?.checkoutState) {
    return <PayNothingCta />;
  }

  if (
    selectedExistingPaymentMethod?.paymentMethodSource ===
    PaymentMethodSource.CHECKOUT
  ) {
    return <PayWithExistingCardCta />;
  }

  if (
    selectedExistingPaymentMethod?.paymentMethodSource ===
    PaymentMethodSource.PAYPAL
  ) {
    return <PayWithExistingPaypalCta />;
  }

  if (selectedNewCheckoutComCard?.isReady) {
    return <PayWithNewCardCta />;
  }

  if (
    selectedNewPaypal?.paypalType === PaypalTypesEnum.PAYPAL ||
    selectedNewPaypal?.paypalType === PaypalTypesEnum.PAYPAL4X
  ) {
    return <PayWithNewPaypalCta />;
  }

  if (selectedNewPaypal?.paypalType === PaypalTypesEnum.PAYPAL_AGREEMENT) {
    return <PayWithNewPaypalAgreementCta />;
  }

  if (selectedNewApplePay) {
    return <PayWithApplePayCta />;
  }

  return <PayCtaDisabled />;
};

export default PaymentActions;
